module.exports = __webpack_public_path__ + "static/img/right-home-row-1.c8e3599a.png";